<div class="command-spinner"
     [@progressState]="status">
  <div [style.visibility]="(isLoading | async) ? 'hidden' : 'inherit'">
    <ng-content></ng-content>
  </div>
  <div class="command-spinner-progress"
       [@control-animation]="isLoading | async"
       [hidden]="(isLoading | async) === false">
    <div class="my-auto d-flex h-100 align-items-center"
         [class.flex-column]="!small()"
         [class.justify-content-center]="!small()"
         [class.flex-row-reverse]="reverse()">
      <ml-sk-spinner-3 class="compact"
                       [hidden]="completed"></ml-sk-spinner-3>
      <div class="status w-100"
           [class.h-100]="small()">
        @switch (status) {
          @case ('Sending') {
            <div>
              <div class="h-100"></div>
              <p class="small text-muted sending"
                 [@text-animation]="direction()"
                 i18n>Sending</p>
            </div>
          }
          @case ('Queued') {
            <div>
              <div class="h-100"></div>
              <p class="small text-muted queued"
                 [@text-animation]="direction()"
                 i18n>Waking</p>
            </div>
          }
          @case ('Send') {
            <div>
              <div class="h-100"></div>
              <p class="small text-muted send"
                 [@text-animation]="direction()"
                 i18n>Executing</p>
            </div>
          }
          @case ('Acknowledged') {
            <div>
              <div class="h-100"></div>
              <p class="small text-success acknowledged"
                 [@text-animation]="direction()"
                 i18n>Completed</p>
            </div>
          }
          @case ('Error') {
            <div>
              <div class="h-100"></div>
              <p class="small text-danger error"
                 [@text-animation]="direction()"
                 i18n>Error: {{ error }}</p>
            </div>
          }
          @case ('CommandFormatError') {
            <div>
              <div class="h-100"></div>
              <p class="small text-danger command-format-error"
                 [@text-animation]="direction()"
                 i18n>
                Command error: {{ error }}
              </p>
            </div>
          }
          @case ('NotNow') {
            <div>
              <div class="h-100"></div>
              <p class="small text-warning not-now"
                 [@text-animation]="direction()"
                 i18n>Not now</p>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>